import React, { FC, useState } from "react";
import { Button, KIND, TButtonProps } from "kanopi-components/Button";
import { ContactUsContent } from "./ContactUsContent";
import { Modal } from "kanopi-components/Modal";
import { StyledLink } from "kanopi-components/Link/StyledLink";
import { useStyletron } from "kanopi-components/theme/useStyletron";

type TContactUs = {
  buttonType?: "link" | "button";
  buttonText?: string;
  openAs?: "modal" | "page";
} & TButtonProps;
/**
 * Button or Link for contact us page/modal
 * Avoid using this component for scenarios where button type is link and requires
 * navigation to contact-us page. Instead, use <Link> component of reach-router.
 * @param buttonType {"link" | "button"}
 * @param openAs {"modal" | "page"}
 * @returns
 */
export const ContactUsModal: FC<TContactUs> = ({
  buttonType = "link",
  buttonText = "Contact us",
  openAs = "modal",
  kind = buttonType === "link" ? KIND.tertiary : KIND.primary,
  ...props
}) => {
  const [, theme] = useStyletron();
  const [isOpen, setIsOpen] = useState(false);
  const onClick = (e) => {
    e.preventDefault();
    if (openAs === "modal") {
      setIsOpen(!isOpen);
    } else {
      window.location.href = "/contact-us";
    }
  };
  const onModalClose = () => {
    setIsOpen(false);
  };
  return (
    <>
      {buttonType === "link" ? (
        <StyledLink
          onClick={onClick}
          href="#"
          data-testid="contact-us-link"
          style={{
            textDecoration: "none",
            fontWeight: 300,
            fontSize: theme.typography.font300.fontSize,
          }}
        >
          {buttonText}
        </StyledLink>
      ) : (
        <Button kind={kind} onClick={onClick} {...props} data-testid="contact-us-link">
          {buttonText}
        </Button>
      )}

      {openAs === "modal" && (
        <Modal isOpen={isOpen} closeable onClose={onModalClose}>
          <Modal.Body>
            <ContactUsContent />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};
